import 'bootstrap/dist/css/bootstrap.css';
import { useEffect, useState } from 'react';
import { Button, Col, Form, Row } from 'react-bootstrap';
import { format, set } from 'date-fns';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import ArquivoService from '../../services/arquivoService';
import CustomAlert from '../../shared/customAlert';
import { useVerificaPermissao } from '../../shared/useVerificaPermissao';
import { ArquivoDTO } from '../../shared/dto/arquivoDTO';
import { faDownload, faEraser, faEye, faFilter, faRefresh, faTimes } from '@fortawesome/free-solid-svg-icons';
import Spinner from '../../shared/spinner';
import ScrollToTopButton from '../../shared/scrollToTopButton';
import LogService from '../../services/logService';
import { LogSimulacaoDTO } from '../../shared/dto/logSimulacaoDTO';
import { LogConsultaMargemDTO } from '../../shared/dto/logConsultaMargemDTO';
import { UUID } from 'crypto';
import { TipoTransacaoDTO } from '../../shared/dto/tipoTransacaoDTO';
import { FiltroLogDTO } from '../../shared/dto/filtroLogDTO';
import ResponsivePagination from 'react-responsive-pagination';
import { LogTransacao } from '../../shared/model/logTransacao';
import { LogTransacaoDTO } from '../../shared/dto/logTransacaoDTO';
import { LogLoginDTO } from '../../shared/dto/logLoginDTO';
import InputMask from 'react-input-mask';
import PromotoraService from '../../services/promotoraService';
import EmpregadorService from '../../services/empregadorService';
import PontoVendaService from '../../services/pontoVendaService';
import { Empregador } from '../../shared/model/empregador';
import { Promotora } from '../../shared/model/promotora';
import { PontoVenda } from '../../shared/model/pontoVenda';

function LogsComponent() {
  useVerificaPermissao();
  const [alert, setAlert] = useState<{ message: string, type: 'success' | 'warning' | 'error' } | null>(null);
  const [loading, setLoading] = useState(true);
  const [botaoPagina, setBotaoPagina] = useState(1);

  const [arquivosDTODebug, setArquivosDTODebug] = useState<ArquivoDTO[]>([]);
  const [logLogin, setLogLogin] = useState<LogLoginDTO[]>([]);
  const [logTransacao, setLogTransacao] = useState<LogTransacaoDTO[]>([]);
  const [exibeDetalheLogTransacao, setExibeDetalheLogTransacao] = useState(false);
  const [logTransacaoDetalhe, setLogTransacaoDetalhe] = useState<LogTransacao | null>();
  const [logConsultaMargem, setLogConsultaMargem] = useState<LogConsultaMargemDTO[]>([]);
  const [logSimulacao, setLogSimulacao] = useState<LogSimulacaoDTO[]>([]);
  const [tiposTransacao, setTiposTransacao] = useState<TipoTransacaoDTO[]>([]);
  const [empregadores, setEmpregadores] = useState<Empregador[]>([]);
  const [promotoras, setPromotoras] = useState<Promotora[]>([]);
  const [pontoVendas, setPontoVendas] = useState<PontoVenda[]>([]);

  const [filtros, setFiltros] = useState(false);
  const [usuarioIdFiltro, setUsuarioIdFiltro] = useState('');
  const [usuarioLoginFiltro, setUsuarioLoginFiltro] = useState('');
  const [usuarioNomeFiltro, setUsuarioNomeFiltro] = useState('');
  const [dataHoraInicioFiltro, setDataHoraInicioFiltro] = useState<string>();
  const [dataHoraFimFiltro, setDataHoraFimFiltro] = useState<string>();
  const [ipAcessoFiltro, setIpAcessoFiltro] = useState('');
  const [tipoTransacaoLogFiltro, setTipoTransacaoLogFiltro] = useState(0);
  const [statusFiltro, setStatusLogFiltro] = useState<boolean | null>(null);
  const [nomeClienteFiltro, setNomeClienteFiltro] = useState('');
  const [cpfClienteFiltro, setCpfClienteFiltro] = useState('');
  const [matriculaClienteFiltro, setMatriculaClienteFiltro] = useState('');
  const [empregadorFiltro, setEmpregadorFiltro] = useState('');
  const [promotoraFiltro, setPromotoraFiltro] = useState('');
  const [pontoVendaFiltro, setPontoVendaFiltro] = useState('');
  const [propostaSolicitadaFiltro, setPropostaSolicitadaFiltro] = useState<boolean | null>(null);

  const qtdRegistros = [10, 20, 30, 50, 100];
  const [pageSize, setPageSize] = useState(20);
  const [currentPageLogin, setCurrentPageLogin] = useState(0);
  const [currentPageTransacao, setCurrentPageTransacao] = useState(0);
  const [currentPageConsultaMargem, setCurrentPageConsultaMargem] = useState(0);
  const [currentPageSimulacao, setCurrentPageSimulacao] = useState(0);
  const [totalPages, setTotalPages] = useState(0);

  const arquivoService: ArquivoService = new ArquivoService();
  const logService: LogService = new LogService();
  const empregadorService: EmpregadorService = new EmpregadorService();
  const promotoraService: PromotoraService = new PromotoraService();
  const pontoVendaService: PontoVendaService = new PontoVendaService();

  const limparCamposFiltro = () => {
    setUsuarioIdFiltro('');
    setUsuarioLoginFiltro('');
    setUsuarioNomeFiltro('');
    setDataHoraInicioFiltro('');
    setDataHoraFimFiltro('');
    setIpAcessoFiltro('');
    setTipoTransacaoLogFiltro(0);
    setStatusLogFiltro(null);
    setNomeClienteFiltro('');
    setCpfClienteFiltro('');
    setMatriculaClienteFiltro('');
    setEmpregadorFiltro('');
    setPromotoraFiltro('');
    setPontoVendaFiltro('');
    setPropostaSolicitadaFiltro(null);
  };

  const listarArquivosLogs = async () => {
    try {
      setFiltros(false);
      setLoading(true);
      const response = await arquivoService.listarArquivosLogs();
      setArquivosDTODebug(response.data);
      setLoading(false);
    } catch (error: any) {
      setLoading(false);
    }
  };

  const downloadArquivo = async (nomeArquivo: string) => {
    setLoading(true);
    try {
      await arquivoService.downloadArquivoLogs(nomeArquivo)
        .then((resp) => {
          const blob = new Blob([resp.data], { type: resp.headers['content-type'] });
          const urlBlob = window.URL.createObjectURL(blob);
          const linkDownload = document.createElement('a');
          linkDownload.href = urlBlob;
          linkDownload.download = nomeArquivo;
          document.body.appendChild(linkDownload);
          linkDownload.click();
          document.body.removeChild(linkDownload);
          window.URL.revokeObjectURL(urlBlob);
          setLoading(false);
        });
    } catch (err) {
      setLoading(false);
      console.error(err);
    }
  };

  const listarLogLogin = async (max: number) => {
    try {
      setFiltros(false);
      setLoading(true);

      let filtro: FiltroLogDTO = new FiltroLogDTO();
      filtro.usuarioId = usuarioIdFiltro ? parseInt(usuarioIdFiltro) : null;
      filtro.usuarioLogin = usuarioLoginFiltro ? usuarioLoginFiltro : null;
      filtro.usuarioNome = usuarioNomeFiltro ? usuarioNomeFiltro : null;
      filtro.dataHoraInicio = dataHoraInicioFiltro ? (dataHoraInicioFiltro) : null;
      filtro.dataHoraFim = dataHoraFimFiltro ? (dataHoraFimFiltro) : null;
      filtro.ipAcesso = ipAcessoFiltro ? ipAcessoFiltro : null;
      filtro.status = statusFiltro;

      const responseList = await logService.listarLogLoginPorFiltro(currentPageLogin, max, filtro);
      const jsonList: LogLoginDTO[] = responseList.data.content;
      setLogLogin(jsonList);
      setTotalPages(responseList.data.totalPages);

      setLoading(false);
    } catch (error: any) {
      setLoading(false);
    }
  };

  const listarLogTransacao = async (max: number) => {
    setFiltros(false);
    setExibeDetalheLogTransacao(false);
    setLogTransacaoDetalhe(null);
    try {
      setLoading(true);

      let filtro: FiltroLogDTO = new FiltroLogDTO();
      filtro.usuarioId = usuarioIdFiltro ? parseInt(usuarioIdFiltro) : null;
      filtro.usuarioLogin = usuarioLoginFiltro ? usuarioLoginFiltro : null;
      filtro.usuarioNome = usuarioNomeFiltro ? usuarioNomeFiltro : null;
      filtro.dataHoraInicio = dataHoraInicioFiltro ? (dataHoraInicioFiltro) : null;
      filtro.dataHoraFim = dataHoraFimFiltro ? (dataHoraFimFiltro) : null;
      filtro.ipAcesso = ipAcessoFiltro ? ipAcessoFiltro : null;
      filtro.tipoTransacaoLog = tipoTransacaoLogFiltro !== 0 ? tipoTransacaoLogFiltro : null;

      const responseList = await logService.listarLogTransacaoPorFiltro(currentPageTransacao, max, filtro);
      const jsonList: LogTransacaoDTO[] = responseList.data.content;
      setLogTransacao(jsonList);
      setTotalPages(responseList.data.totalPages);
      setLoading(false);
    } catch (error: any) {
      setLoading(false);
    }
  };

  const verDetalhesLogTransacao = async (id: UUID) => {
    try {
      setFiltros(false);
      setLoading(true);
      const response = await logService.listarLogTransacaoPorId(id);
      setLogTransacaoDetalhe(response.data);
      setExibeDetalheLogTransacao(true);
      scrollToBottom();
      setLoading(false);
    } catch (error: any) {
      setLoading(false);
    }
  }

  const listarLogConsultaMargem = async (max: number) => {
    try {
      setFiltros(false);
      setLoading(true);

      let filtro: FiltroLogDTO = new FiltroLogDTO();
      filtro.usuarioId = usuarioIdFiltro ? parseInt(usuarioIdFiltro) : null;
      filtro.usuarioLogin = usuarioLoginFiltro ? usuarioLoginFiltro : null;
      filtro.usuarioNome = usuarioNomeFiltro ? usuarioNomeFiltro : null;
      filtro.dataHoraInicio = dataHoraInicioFiltro ? (dataHoraInicioFiltro) : null;
      filtro.dataHoraFim = dataHoraFimFiltro ? (dataHoraFimFiltro) : null;
      filtro.ipAcesso = ipAcessoFiltro ? ipAcessoFiltro : null;
      filtro.status = statusFiltro;
      filtro.cpfCliente = cpfClienteFiltro ? cpfClienteFiltro : null;
      filtro.nomeCliente = nomeClienteFiltro ? nomeClienteFiltro : null;
      filtro.matriculaCliente = matriculaClienteFiltro ? matriculaClienteFiltro : null;
      filtro.idEmpregador = empregadorFiltro ? parseInt(empregadorFiltro) : null;
      filtro.idPromotora = promotoraFiltro ? parseInt(promotoraFiltro) : null;
      filtro.idPontoVenda = pontoVendaFiltro ? parseInt(pontoVendaFiltro) : null;

      const responseList = await logService.listarLogConsultaMargemPorFiltro(currentPageConsultaMargem, max, filtro);
      const jsonList: LogConsultaMargemDTO[] = responseList.data.content;
      setLogConsultaMargem(jsonList);
      setTotalPages(responseList.data.totalPages);

      setLoading(false);
    } catch (error: any) {
      setLoading(false);
    }
  };

  const listarLogSimulacao = async (max: number) => {
    try {
      setFiltros(false);
      setLoading(true);

      let filtro: FiltroLogDTO = new FiltroLogDTO();
      filtro.usuarioId = usuarioIdFiltro ? parseInt(usuarioIdFiltro) : null;
      filtro.usuarioLogin = usuarioLoginFiltro ? usuarioLoginFiltro : null;
      filtro.usuarioNome = usuarioNomeFiltro ? usuarioNomeFiltro : null;
      filtro.dataHoraInicio = dataHoraInicioFiltro ? (dataHoraInicioFiltro) : null;
      filtro.dataHoraFim = dataHoraFimFiltro ? (dataHoraFimFiltro) : null;
      filtro.ipAcesso = ipAcessoFiltro ? ipAcessoFiltro : null;
      filtro.cpfCliente = cpfClienteFiltro ? cpfClienteFiltro : null;
      filtro.nomeCliente = nomeClienteFiltro ? nomeClienteFiltro : null;
      filtro.matriculaCliente = matriculaClienteFiltro ? matriculaClienteFiltro : null;
      filtro.idEmpregador = empregadorFiltro ? parseInt(empregadorFiltro) : null;
      filtro.idPromotora = promotoraFiltro ? parseInt(promotoraFiltro) : null;
      filtro.idPontoVenda = pontoVendaFiltro ? parseInt(pontoVendaFiltro) : null;
      filtro.propostaSolicitada = propostaSolicitadaFiltro;

      const responseList = await logService.listarLogSimulacaoPorFiltro(currentPageSimulacao, max, filtro);
      const jsonList: LogSimulacaoDTO[] = responseList.data.content;
      setLogSimulacao(jsonList);
      setTotalPages(responseList.data.totalPages);
      setLoading(false);
    } catch (error: any) {
      setLoading(false);
    }
  };

  const listarTiposTransacao = async () => {
    try {
      setLoading(true);
      const response = await logService.listarTiposTransacaoLog();
      setTiposTransacao(response.data);
      setLoading(false);
    } catch (error: any) {
      setLoading(false);
    }
  };

  const listarEmpregadores = async () => {
    try {
      setLoading(true);
      const response = await empregadorService.listarTodosEmpregadores();
      setEmpregadores(response.data);
    } catch (error: any) {
      console.log(error);
    } finally {
      setLoading(false);
    }
  };

  const listarPromotoras = async (filtros = {}) => {
    try {
      setLoading(true);
      const response = await promotoraService.listarTodasPromotoras(0, 9999999, filtros);
      setPromotoras(response.data);
    } catch (error: any) {
      console.log(error);
    } finally {
      setLoading(false);
    }
  };

  const listarPontoVendas = async () => {
    try {
      setLoading(true);
      const response = await pontoVendaService.listarTodosPontosVendas();
      setPontoVendas(response.data);
    } catch (error: any) {
      console.log(error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    listarArquivosLogs();
    listarTiposTransacao();
    listarEmpregadores();
    listarPromotoras();
    listarPontoVendas();
  }, []);

  useEffect(() => {
    listarLogTransacao(pageSize);
  }, [currentPageTransacao]);

  useEffect(() => {
    listarLogLogin(pageSize);
  }, [currentPageLogin]);

  useEffect(() => {
    listarLogConsultaMargem(pageSize);
  }, [currentPageConsultaMargem]);

  useEffect(() => {
    listarLogSimulacao(pageSize);
  }, [currentPageSimulacao]);

  interface JsonDiff {
    key: string;
    value1: any;
    value2: any;
  }

  const renderJsonWithDifferences = (jsonString1: string | null, jsonString2: string | null) => {
    try {
      if (jsonString1 === null && jsonString2 === null) {
        return <span>{""}</span>;
      }

      const isJson = (str: string) => {
        try {
          JSON.parse(str);
          return true;
        } catch {
          return false;
        }
      };

      if (jsonString2 === null) {
        if (isJson(jsonString1 || "")) {
          const jsonObject1 = JSON.parse(jsonString1 || "{}");
          return (
            <div style={{ flex: 1 }}>
              <pre style={{ background: "#f8f9fa", padding: "10px", borderRadius: "5px" }}>
                {JSON.stringify(jsonObject1, null, 2)}
              </pre>
            </div>
          );
        } else {
          return <span>{jsonString1}</span>;
        }
      }

      if (!isJson(jsonString1 || "") || !isJson(jsonString2 || "")) {
        return (
          <div style={{ display: 'flex', justifyContent: 'space-between' }}>
            <div style={{ flex: 1, marginRight: '10px' }}>
              <pre style={{ background: "#f8f9fa", padding: "10px", borderRadius: "5px" }}>
                {jsonString1}
              </pre>
            </div>
            <div style={{ flex: 1 }}>
              <pre style={{ background: "#f8f9fa", padding: "10px", borderRadius: "5px" }}>
                {jsonString2}
              </pre>
            </div>
          </div>
        );
      }

      const jsonObject1 = JSON.parse(jsonString1 || "{}");
      const jsonObject2 = JSON.parse(jsonString2 || "{}");

      const getHighlightedJson = (obj1: any, obj2: any): JsonDiff[] => {
        const keys = new Set([...Object.keys(obj1), ...Object.keys(obj2)]);
        const differences: JsonDiff[] = [];

        keys.forEach((key) => {
          if (obj1[key] === undefined || obj2[key] === undefined || JSON.stringify(obj1[key]) !== JSON.stringify(obj2[key])) {
            differences.push({
              key,
              value1: obj1[key],
              value2: obj2[key],
            });
          }
        });

        return differences;
      };

      const differences = getHighlightedJson(jsonObject1, jsonObject2);

      const renderData = (json: any, compareJson: any, differences: JsonDiff[]) => {
        return Object.keys({ ...json, ...compareJson }).map((key) => {
          const isDifferent = differences.some((diff) => diff.key === key);
          const value = json[key] === undefined ? '---' : json[key];

          return (
            <div key={key}>
              <strong>{key}:</strong>{" "}
              <span
                style={{
                  color: isDifferent ? 'red' : 'black',
                }}
              >
                {JSON.stringify(value, null, 2)}
              </span>
            </div>
          );
        });
      };

      return (
        <div style={{ display: 'flex', justifyContent: 'space-between' }}>
          <div style={{ flex: 1, marginRight: '10px' }}>
            <span style={{ fontWeight: 'bold', fontSize: '14px' }}>Novo: </span>
            <pre style={{ background: "#f8f9fa", padding: "10px", borderRadius: "5px" }}>
              {renderData(jsonObject1, jsonObject2, differences)}
            </pre>
          </div>
          <div style={{ flex: 1 }}>
            <span style={{ fontWeight: 'bold', fontSize: '14px' }}>Antigo: </span>
            <pre style={{ background: "#f8f9fa", padding: "10px", borderRadius: "5px" }}>
              {renderData(jsonObject2, jsonObject1, differences)}
            </pre>
          </div>
        </div>
      );
    } catch (e) {
      return <span>{jsonString1}</span>;
    }
  };

  const scrollToBottom = () => {
    setTimeout(() => {
      window.scrollTo({
        top: document.documentElement.scrollHeight,
        behavior: 'smooth',
      });
    }, 100);
  };

  return (
    <>
      {alert && (<CustomAlert message={alert.message} type={alert.type} onClose={() => setAlert(null)} />)}
      <div className="position-relative m-md-3">
        <div style={{ marginBottom: '15px', display: 'flex', justifyContent: 'space-between' }}>
          <h5>Sistema &gt; Logs</h5>
        </div>
        {loading ? <Spinner loading={loading} /> : (
          <>
            <div>
              <Button style={{ backgroundColor: '#6c757d', borderColor: '#6c757d', color: 'white', width: '10%', height: '50px' }}
                onClick={() => { setBotaoPagina(1); listarArquivosLogs(); limparCamposFiltro(); }}>
                Debug
              </Button>
              <Button style={{ backgroundColor: '#6c757d', borderColor: '#6c757d', color: 'white', width: '10%', height: '50px', marginLeft: '10px' }}
                onClick={() => { setBotaoPagina(2); listarLogLogin(pageSize); limparCamposFiltro(); setPageSize(20); }}>
                Login
              </Button>
              <Button style={{ backgroundColor: '#6c757d', borderColor: '#6c757d', color: 'white', width: '15%', height: '50px', marginLeft: '10px' }}
                onClick={() => { setBotaoPagina(3); listarLogTransacao(pageSize); limparCamposFiltro(); setPageSize(20); }}>
                Transação
              </Button>
              <Button style={{ backgroundColor: '#6c757d', borderColor: '#6c757d', color: 'white', width: '15%', height: '50px', marginLeft: '10px' }}
                onClick={() => { setBotaoPagina(4); listarLogConsultaMargem(pageSize); limparCamposFiltro(); setPageSize(20); }}>
                Consulta Margem
              </Button>
              <Button style={{ backgroundColor: '#6c757d', borderColor: '#6c757d', color: 'white', width: '15%', height: '50px', marginLeft: '10px' }}
                onClick={() => { setBotaoPagina(5); listarLogSimulacao(pageSize); limparCamposFiltro(); setPageSize(20); }}>
                Simulação
              </Button>
            </div>
            {botaoPagina === 1 ? (
              <div className="table-responsive" style={{ marginTop: '25px', visibility: 'visible', overflowY: 'auto', width: '100%', borderWidth: '1px' }}>
                <table className="table table-bordered table-striped">
                  <tbody>
                    <tr className="GridHeaderStyle" id="App-button-cor-principal" style={{ color: 'White' }}>
                      <th scope="col" id="App-header-table-esquerda">Nome</th>
                      <th scope="col" id="App-header-table-esquerda">Data</th>
                      <th scope="col" id="App-header-table-esquerda">Download</th>
                    </tr>
                    {arquivosDTODebug.map((item, index) => (
                      <tr className="GridRowStyle">
                        <td>{item.nomeArquivo}</td>
                        <td>{item.dtInclusao ? format(new Date(item.dtInclusao), 'dd/MM/yyyy') : ''}</td>
                        <td align="left">
                          <a onClick={() => downloadArquivo(item.nomeArquivo)}>
                            <Button>
                              <FontAwesomeIcon icon={faDownload} />
                            </Button>
                          </a>
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            ) : botaoPagina === 2 ? (
              <>
                <div style={{ marginTop: '25px', display: 'flex', justifyContent: 'space-between' }}>
                  <Button id="App-button-cor-principal-escura" onClick={() => setFiltros(!filtros)}>
                    <FontAwesomeIcon icon={faFilter} style={{ marginRight: '10px' }} />
                    Filtros
                  </Button>
                  <Button id="App-button-cor-principal-escura" onClick={() => listarLogLogin(pageSize)}>
                    <FontAwesomeIcon icon={faRefresh} style={{ marginRight: '1px' }} />
                  </Button>
                </div>
                {filtros ?
                  <>
                    <Row className="mb-4" style={{ marginTop: '15px' }}>
                      <Form.Group as={Col} md='1' controlId="formBasicSelect">
                        <Form.Label>Usuário ID </Form.Label>
                        <input type="number" className="form-control" value={usuarioIdFiltro} onChange={(e) => setUsuarioIdFiltro(e.target.value)} />
                      </Form.Group>
                      <Form.Group as={Col} md='2' controlId="formBasicSelect">
                        <Form.Label>Usuário Login</Form.Label>
                        <input type="text" className="form-control" value={usuarioLoginFiltro} onChange={(e) => setUsuarioLoginFiltro(e.target.value)} />
                      </Form.Group>
                      <Form.Group as={Col} md='2' controlId="formBasicSelect">
                        <Form.Label>Usuário Nome</Form.Label>
                        <input type="text" className="form-control" value={usuarioNomeFiltro} onChange={(e) => setUsuarioNomeFiltro(e.target.value)} />
                      </Form.Group>
                      <Form.Group as={Col} md="2" controlId="formBasicDateTime">
                        <Form.Label>Data e Hora Inicio</Form.Label>
                        <input type="datetime-local" className="form-control" value={dataHoraInicioFiltro} onChange={(e) => { setDataHoraInicioFiltro(e.target.value); }} />
                      </Form.Group>
                      <Form.Group as={Col} md="2" controlId="formBasicDateTime">
                        <Form.Label>Data e Hora Fim</Form.Label>
                        <input type="datetime-local" className="form-control" value={dataHoraFimFiltro} onChange={(e) => { setDataHoraFimFiltro(e.target.value); }} />
                      </Form.Group>
                      <Form.Group as={Col} md='2' controlId="formBasicSelect">
                        <Form.Label>IP Acesso</Form.Label>
                        <input type="text" className="form-control" value={ipAcessoFiltro} onChange={(e) => setIpAcessoFiltro(e.target.value)} />
                      </Form.Group>
                      <Form.Group as={Col} md="1" controlId="formBasicSelect">
                        <Form.Label>Status</Form.Label>
                        <select className="form-select" value={statusFiltro === null ? "" : statusFiltro.toString()}
                          onChange={(e) => { setStatusLogFiltro(e.target.value === "" ? null : (e.target.value === "false" ? false : true)); }}
                        >
                          <option value="">Todos</option>
                          <option value="true">Sucesso</option>
                          <option value="false">Falha</option>
                        </select>
                      </Form.Group>
                    </Row>
                    <div style={{ marginBottom: '10px', display: 'flex', justifyContent: 'space-between' }}>
                      <Button id="App-button-cor-principal-escura" onClick={() => setFiltros(!filtros)}>
                        <FontAwesomeIcon icon={faFilter} style={{ marginRight: '1px' }} />
                      </Button>
                      <Button id="App-button-cor-principal-escura" onClick={() => limparCamposFiltro()}>
                        <FontAwesomeIcon icon={faEraser} style={{ marginRight: '10px' }} />
                        Limpar Filtros
                      </Button>
                      <Button id="App-button-cor-principal-escura" onClick={() => listarLogLogin(pageSize)}>
                        <FontAwesomeIcon icon={faRefresh} style={{ marginRight: '1px' }} />
                      </Button>
                    </div>
                  </>
                  : null}
                <Row style={{ justifyContent: 'center' }} className="mb-3">
                  <Form.Group style={{ marginTop: '10px' }} as={Col} md='2' controlId="formBasicSelect">Registros Por Página</Form.Group>
                  <Form.Group as={Col} md='1' controlId="formBasicSelect">
                    <select className="form-select"
                      defaultValue={pageSize} value={pageSize} onChange={(e) => {
                        {
                          setPageSize(parseInt(e.target.value));
                          listarLogLogin(parseInt(e.target.value));
                        }
                      }}
                    >
                      {qtdRegistros.map((qtd, index) => (
                        <option key={index} value={qtd}>{qtd}</option>
                      ))}
                    </select>
                  </Form.Group>
                </Row>
                <div className="table-responsive" style={{ marginTop: '25px', visibility: 'visible', overflowY: 'auto', width: '100%', borderWidth: '1px' }}>
                  <table className="table table-bordered table-striped">
                    <tbody>
                      <tr className="GridHeaderStyle" id="App-button-cor-principal" style={{ color: 'White' }}>
                        <th scope="col" id="App-header-table-esquerda">Usuário ID</th>
                        <th scope="col" id="App-header-table-esquerda">Usuário Login</th>
                        <th scope="col" id="App-header-table-esquerda">Usuário Nome</th>
                        <th scope="col" id="App-header-table-esquerda">Data/Hora</th>
                        <th scope="col" id="App-header-table-esquerda">IP Acesso</th>
                        <th scope="col" id="App-header-table-esquerda">Status</th>
                        <th scope="col" id="App-header-table-esquerda">Mensagem</th>
                      </tr>
                      {logLogin.map((item, index) => (
                        <tr className="GridRowStyle">
                          <td>{item?.idUsuario ? item?.idUsuario : '-'}</td>
                          <td>{item?.loginUsuario ? item?.loginUsuario : '-'}</td>
                          <td>{item?.nomeUsuario ? item?.nomeUsuario : '-'}</td>
                          <td>{item.dtInclusao ? format(new Date(item.dtInclusao), 'dd/MM/yyyy HH:mm:ss') : ''}</td>
                          <td>{item?.ipUsuario}</td>
                          <td>{item?.sucesso ? 'Sucesso' : 'Falha'}</td>
                          <td>{item?.mensagem}</td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                  <ResponsivePagination
                    current={currentPageLogin}
                    total={totalPages}
                    onPageChange={setCurrentPageLogin} />
                </div>
              </>
            ) : botaoPagina === 3 ? (
              <>
                <div style={{ marginTop: '25px', display: 'flex', justifyContent: 'space-between' }}>
                  <Button id="App-button-cor-principal-escura" onClick={() => setFiltros(!filtros)}>
                    <FontAwesomeIcon icon={faFilter} style={{ marginRight: '10px' }} />
                    Filtros
                  </Button>
                  <Button id="App-button-cor-principal-escura" onClick={() => listarLogTransacao(pageSize)}>
                    <FontAwesomeIcon icon={faRefresh} style={{ marginRight: '1px' }} />
                  </Button>
                </div>
                {filtros ?
                  <>
                    <Row className="mb-4" style={{ marginTop: '15px' }}>
                      <Form.Group as={Col} md='1' controlId="formBasicSelect">
                        <Form.Label>Usuário ID </Form.Label>
                        <input type="number" className="form-control" value={usuarioIdFiltro} onChange={(e) => setUsuarioIdFiltro(e.target.value)} />
                      </Form.Group>
                      <Form.Group as={Col} md='2' controlId="formBasicSelect">
                        <Form.Label>Usuário Login</Form.Label>
                        <input type="text" className="form-control" value={usuarioLoginFiltro} onChange={(e) => setUsuarioLoginFiltro(e.target.value)} />
                      </Form.Group>
                      <Form.Group as={Col} md='2' controlId="formBasicSelect">
                        <Form.Label>Usuário Nome</Form.Label>
                        <input type="text" className="form-control" value={usuarioNomeFiltro} onChange={(e) => setUsuarioNomeFiltro(e.target.value)} />
                      </Form.Group>
                      <Form.Group as={Col} md="2" controlId="formBasicDateTime">
                        <Form.Label>Data e Hora Inicio</Form.Label>
                        <input type="datetime-local" className="form-control" value={dataHoraInicioFiltro} onChange={(e) => { setDataHoraInicioFiltro(e.target.value); }} />
                      </Form.Group>
                      <Form.Group as={Col} md="2" controlId="formBasicDateTime">
                        <Form.Label>Data e Hora Fim</Form.Label>
                        <input type="datetime-local" className="form-control" value={dataHoraFimFiltro} onChange={(e) => { setDataHoraFimFiltro(e.target.value); }} />
                      </Form.Group>
                      <Form.Group as={Col} md='2' controlId="formBasicSelect">
                        <Form.Label>IP Acesso</Form.Label>
                        <input type="text" className="form-control" value={ipAcessoFiltro} onChange={(e) => setIpAcessoFiltro(e.target.value)} />
                      </Form.Group>
                      <Form.Group as={Col} md='2' controlId="formBasicSelect">
                        <Form.Label>Tipo Transação</Form.Label>
                        <select required className="form-select" value={tipoTransacaoLogFiltro} onChange={(e) => setTipoTransacaoLogFiltro(parseInt(e.target.value))}>
                          <option value="0"> Todos </option>
                          {tiposTransacao.map((item) => (
                            <option key={item.codigo} value={item.codigo}>
                              {item.descricao}
                            </option>
                          ))}
                        </select>
                      </Form.Group>
                    </Row>
                    <div style={{ marginBottom: '10px', display: 'flex', justifyContent: 'space-between' }}>
                      <Button id="App-button-cor-principal-escura" onClick={() => setFiltros(!filtros)}>
                        <FontAwesomeIcon icon={faFilter} style={{ marginRight: '1px' }} />
                      </Button>
                      <Button id="App-button-cor-principal-escura" onClick={() => limparCamposFiltro()}>
                        <FontAwesomeIcon icon={faEraser} style={{ marginRight: '10px' }} />
                        Limpar Filtros
                      </Button>
                      <Button id="App-button-cor-principal-escura" onClick={() => listarLogTransacao(pageSize)}>
                        <FontAwesomeIcon icon={faRefresh} style={{ marginRight: '1px' }} />
                      </Button>
                    </div>
                  </>
                  : null}
                <Row style={{ justifyContent: 'center' }} className="mb-3">
                  <Form.Group style={{ marginTop: '10px' }} as={Col} md='2' controlId="formBasicSelect">Registros Por Página</Form.Group>
                  <Form.Group as={Col} md='1' controlId="formBasicSelect">
                    <select className="form-select"
                      defaultValue={pageSize} value={pageSize} onChange={(e) => {
                        {
                          setPageSize(parseInt(e.target.value));
                          listarLogTransacao(parseInt(e.target.value));
                        }
                      }}
                    >
                      {qtdRegistros.map((qtd, index) => (
                        <option key={index} value={qtd}>{qtd}</option>
                      ))}
                    </select>
                  </Form.Group>
                </Row>
                <div className="table-responsive" style={{ marginTop: '25px', visibility: 'visible', overflowY: 'auto', width: '100%', borderWidth: '1px' }}>
                  <table className="table table-bordered table-striped">
                    <tbody>
                      <tr className="GridHeaderStyle" id="App-button-cor-principal" style={{ color: 'White' }}>
                        <th scope="col" id="App-header-table-esquerda">Usuário ID</th>
                        <th scope="col" id="App-header-table-esquerda">Usuário Login</th>
                        <th scope="col" id="App-header-table-esquerda">Usuário Nome</th>
                        <th scope="col" id="App-header-table-esquerda">Data/Hora</th>
                        <th scope="col" id="App-header-table-esquerda">IP Acesso</th>
                        <th scope="col" id="App-header-table-esquerda">Transação</th>
                        <th scope="col" id="App-header-table-esquerda">Detalhes</th>
                      </tr>
                      {logTransacao.map((item) => (
                        <tr className="GridRowStyle">
                          <td>{item?.idUsuario ? item?.idUsuario : '-'}</td>
                          <td>{item?.loginUsuario ? item?.loginUsuario : '-'}</td>
                          <td>{item?.nomeUsuario ? item?.nomeUsuario : '-'}</td>
                          <td>{item.dtInclusao ? format(new Date(item.dtInclusao), 'dd/MM/yyyy HH:mm:ss') : ''}</td>
                          <td>{item?.ipUsuario}</td>
                          <td>{item?.tipoTransacao}</td>
                          <td>
                            <Button className="btn btn-sm" style={{ display: 'flex', marginLeft: '15px', background: 'grey', border: 'grey' }} title='Detalhes' onClick={() => verDetalhesLogTransacao(item.id)}>
                              <FontAwesomeIcon icon={faEye} />
                            </Button>
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                  <ResponsivePagination
                    current={currentPageTransacao}
                    total={totalPages}
                    onPageChange={setCurrentPageTransacao} />
                  {exibeDetalheLogTransacao && logTransacaoDetalhe && (
                    <form>
                      <div className="card" style={{ marginTop: '25px' }}>
                        <div className="card-header" style={{ display: 'flex', justifyContent: 'space-between' }}>
                          <strong>Detalhes do Log de Transação</strong>
                          <Button className="btn btn-sm" style={{ display: 'flex', marginLeft: '15px', background: 'grey', border: 'grey' }} title='Fechar' onClick={() => { setExibeDetalheLogTransacao(false); setLogTransacaoDetalhe(null); }}>
                            <FontAwesomeIcon icon={faTimes} />
                          </Button>
                        </div>
                        <div className="card-body" style={{ visibility: 'visible', overflowY: 'auto', width: '100%', borderWidth: '1px' }}>
                          <p><strong>Data e Hora:</strong> {logTransacaoDetalhe.dtInclusao ? format(new Date(logTransacaoDetalhe.dtInclusao), 'dd/MM/yyyy HH:mm:ss') : ''}</p>
                          <p><strong>Usuário:</strong> {logTransacaoDetalhe.usuario ? logTransacaoDetalhe.usuario.login : ' - '}</p>
                          <p><strong>IP Usuário:</strong> {logTransacaoDetalhe.ipUsuario}</p>
                          <p><strong>Tipo de Transação:</strong> {logTransacaoDetalhe.tipoTransacaoNome}</p>
                          <div>
                            <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                              <div style={{ flex: 1, marginRight: '10px' }}>
                                <strong>Dados: </strong>
                                {renderJsonWithDifferences(logTransacaoDetalhe.dadosNovosString, logTransacaoDetalhe.dadosAntigosString)}
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </form>
                  )}
                </div>
              </>
            ) : botaoPagina === 4 ? (
              <>
                <div style={{ marginTop: '25px', display: 'flex', justifyContent: 'space-between' }}>
                  <Button id="App-button-cor-principal-escura" onClick={() => setFiltros(!filtros)}>
                    <FontAwesomeIcon icon={faFilter} style={{ marginRight: '10px' }} />
                    Filtros
                  </Button>
                  <Button id="App-button-cor-principal-escura" onClick={() => listarLogConsultaMargem(pageSize)}>
                    <FontAwesomeIcon icon={faRefresh} style={{ marginRight: '1px' }} />
                  </Button>
                </div>
                {filtros ?
                  <>
                    <Row className="mb-4" style={{ marginTop: '15px' }}>
                      <Form.Group as={Col} md='1' controlId="formBasicSelect">
                        <Form.Label>Usuário ID </Form.Label>
                        <input type="number" className="form-control" value={usuarioIdFiltro} onChange={(e) => setUsuarioIdFiltro(e.target.value)} />
                      </Form.Group>
                      <Form.Group as={Col} md='2' controlId="formBasicSelect">
                        <Form.Label>Usuário Login</Form.Label>
                        <input type="text" className="form-control" value={usuarioLoginFiltro} onChange={(e) => setUsuarioLoginFiltro(e.target.value)} />
                      </Form.Group>
                      <Form.Group as={Col} md='2' controlId="formBasicSelect">
                        <Form.Label>Usuário Nome</Form.Label>
                        <input type="text" className="form-control" value={usuarioNomeFiltro} onChange={(e) => setUsuarioNomeFiltro(e.target.value)} />
                      </Form.Group>
                      <Form.Group as={Col} md="2" controlId="formBasicDateTime">
                        <Form.Label>Data e Hora Inicio</Form.Label>
                        <input type="datetime-local" className="form-control" value={dataHoraInicioFiltro} onChange={(e) => { setDataHoraInicioFiltro(e.target.value); }} />
                      </Form.Group>
                      <Form.Group as={Col} md="2" controlId="formBasicDateTime">
                        <Form.Label>Data e Hora Fim</Form.Label>
                        <input type="datetime-local" className="form-control" value={dataHoraFimFiltro} onChange={(e) => { setDataHoraFimFiltro(e.target.value); }} />
                      </Form.Group>
                      <Form.Group as={Col} md='2' controlId="formBasicSelect">
                        <Form.Label>IP Acesso</Form.Label>
                        <input type="text" className="form-control" value={ipAcessoFiltro} onChange={(e) => setIpAcessoFiltro(e.target.value)} />
                      </Form.Group>
                      <Form.Group as={Col} md="1" controlId="formBasicSelect">
                        <Form.Label>Status</Form.Label>
                        <select className="form-select" value={statusFiltro === null ? "" : statusFiltro.toString()}
                          onChange={(e) => { setStatusLogFiltro(e.target.value === "" ? null : (e.target.value === "false" ? false : true)); }}
                        >
                          <option value="">Todos</option>
                          <option value="true">Sucesso</option>
                          <option value="false">Falha</option>
                        </select>
                      </Form.Group>
                      <Form.Group as={Col} md='2' controlId="formBasicSelect">
                        <Form.Label>CPF Cliente</Form.Label>
                        <InputMask required mask="999.999.999-99" type="text" className="form-control" value={cpfClienteFiltro} onChange={(e) => setCpfClienteFiltro(e.target.value)} />
                      </Form.Group>
                      <Form.Group as={Col} md='2' controlId="formBasicSelect">
                        <Form.Label>Nome Cliente</Form.Label>
                        <input type="text" className="form-control" value={nomeClienteFiltro} onChange={(e) => setNomeClienteFiltro(e.target.value)} />
                      </Form.Group>
                      <Form.Group as={Col} md='2' controlId="formBasicSelect">
                        <Form.Label>Matricula Cliente</Form.Label>
                        <input type="text" className="form-control" value={matriculaClienteFiltro} onChange={(e) => setMatriculaClienteFiltro(e.target.value)} />
                      </Form.Group>
                      <Form.Group as={Col} md='2' controlId="formBasicSelect">
                        <Form.Label>Empregador</Form.Label>
                        <select required className="form-select" value={empregadorFiltro} onChange={(e) => setEmpregadorFiltro(e.target.value)}>
                          <option value=""> Todos </option>
                          {empregadores.map((item) => (
                            <option key={item.id} value={item.id!}>
                              {item.id} - {item.nome}
                            </option>
                          ))}
                        </select>
                      </Form.Group>
                      <Form.Group as={Col} md='2' controlId="formBasicSelect">
                        <Form.Label>Promotora</Form.Label>
                        <select required className="form-select" value={promotoraFiltro} onChange={(e) => setPromotoraFiltro(e.target.value)}>
                          <option value=""> Todas </option>
                          {promotoras.map((item) => (
                            <option key={item.id} value={item.id!}>
                              {item.id} - {item.nome}
                            </option>
                          ))}
                        </select>
                      </Form.Group>
                      <Form.Group as={Col} md='2' controlId="formBasicSelect">
                        <Form.Label>Ponto de Venda</Form.Label>
                        <select required className="form-select" value={pontoVendaFiltro} onChange={(e) => setPontoVendaFiltro(e.target.value)}>
                          <option value=""> Todas </option>
                          {pontoVendas.map((item) => (
                            <option key={item.id} value={item.id!}>
                              {item.id} - {item.nome}
                            </option>
                          ))}
                        </select>
                      </Form.Group>
                    </Row>
                    <div style={{ marginBottom: '10px', display: 'flex', justifyContent: 'space-between' }}>
                      <Button id="App-button-cor-principal-escura" onClick={() => setFiltros(!filtros)}>
                        <FontAwesomeIcon icon={faFilter} style={{ marginRight: '1px' }} />
                      </Button>
                      <Button id="App-button-cor-principal-escura" onClick={() => limparCamposFiltro()}>
                        <FontAwesomeIcon icon={faEraser} style={{ marginRight: '10px' }} />
                        Limpar Filtros
                      </Button>
                      <Button id="App-button-cor-principal-escura" onClick={() => listarLogConsultaMargem(pageSize)}>
                        <FontAwesomeIcon icon={faRefresh} style={{ marginRight: '1px' }} />
                      </Button>
                    </div>
                  </>
                  : null}
                <Row style={{ justifyContent: 'center' }} className="mb-3">
                  <Form.Group style={{ marginTop: '10px' }} as={Col} md='2' controlId="formBasicSelect">Registros Por Página</Form.Group>
                  <Form.Group as={Col} md='1' controlId="formBasicSelect">
                    <select className="form-select"
                      defaultValue={pageSize} value={pageSize} onChange={(e) => {
                        {
                          setPageSize(parseInt(e.target.value));
                          listarLogConsultaMargem(parseInt(e.target.value));
                        }
                      }}
                    >
                      {qtdRegistros.map((qtd, index) => (
                        <option key={index} value={qtd}>{qtd}</option>
                      ))}
                    </select>
                  </Form.Group>
                </Row>
                <div className="table-responsive" style={{ fontSize: '12px', marginTop: '25px', visibility: 'visible', overflowY: 'auto', width: '100%', borderWidth: '1px' }}>
                  <table className="table table-bordered table-striped">
                    <tbody>
                      <tr className="GridHeaderStyle" id="App-button-cor-principal" style={{ color: 'White' }}>
                        <th scope="col" id="App-header-table-esquerda">ID-Login-Nome</th>
                        <th scope="col" id="App-header-table-esquerda">Data/Hora</th>
                        <th scope="col" id="App-header-table-esquerda">IP Acesso</th>
                        <th scope="col" id="App-header-table-esquerda">Tempo (ms)</th>
                        <th scope="col" id="App-header-table-esquerda">Mensagem</th>
                        <th scope="col" id="App-header-table-esquerda">Status</th>
                        <th scope="col" id="App-header-table-esquerda">CPF</th>
                        <th scope="col" id="App-header-table-esquerda">Nome</th>
                        <th scope="col" id="App-header-table-esquerda">Matricula</th>
                        <th scope="col" id="App-header-table-esquerda">Secretaria</th>
                        <th scope="col" id="App-header-table-esquerda">Situação</th>
                        <th scope="col" id="App-header-table-esquerda">Tipo Servidor</th>
                        <th scope="col" id="App-header-table-esquerda">RMC</th>
                        <th scope="col" id="App-header-table-esquerda">Empregador</th>
                        <th scope="col" id="App-header-table-esquerda">Promotora</th>
                        <th scope="col" id="App-header-table-esquerda">Ponto de Venda</th>
                      </tr>
                      {logConsultaMargem.map((item, index) => (
                        <tr className="GridRowStyle">
                          <td>{item?.idUsuario}-{item?.loginUsuario}-{item?.nomeUsuario}</td>
                          <td>{item?.dtInclusao ? format(new Date(item.dtInclusao), 'dd/MM/yyyy HH:mm:ss') : ''}</td>
                          <td>{item?.ipUsuario}</td>
                          <td>{item?.duracaoRequisicao ? item.duracaoRequisicao : ''}</td>
                          <td>{item?.mensagem}</td>
                          <td>{item?.sucesso ? 'Sucesso' : 'Falha'}</td>
                          <td>{item?.cpf}</td>
                          <td>{item?.nome}</td>
                          <td>{item?.matricula}</td>
                          <td>{item?.secretaria}</td>
                          <td>{item?.situacao}</td>
                          <td>{item?.tipoServidor}</td>
                          <td>{item.valorMargem ? item.valorMargem.toLocaleString('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) : ''}</td>
                          <td>{item?.empregador}</td>
                          <td>{item?.promotora}</td>
                          <td>{item?.pontoVenda}</td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                  <ResponsivePagination
                    current={currentPageConsultaMargem}
                    total={totalPages}
                    onPageChange={setCurrentPageConsultaMargem} />
                </div>
              </>
            ) : botaoPagina === 5 ? (
              <>
                <div style={{ marginTop: '25px', display: 'flex', justifyContent: 'space-between' }}>
                  <Button id="App-button-cor-principal-escura" onClick={() => setFiltros(!filtros)}>
                    <FontAwesomeIcon icon={faFilter} style={{ marginRight: '10px' }} />
                    Filtros
                  </Button>
                  <Button id="App-button-cor-principal-escura" onClick={() => listarLogSimulacao(pageSize)}>
                    <FontAwesomeIcon icon={faRefresh} style={{ marginRight: '1px' }} />
                  </Button>
                </div>
                {filtros ?
                  <>
                    <Row className="mb-4" style={{ marginTop: '15px' }}>
                      <Form.Group as={Col} md='2' controlId="formBasicSelect">
                        <Form.Label>Usuário ID </Form.Label>
                        <input type="number" className="form-control" value={usuarioIdFiltro} onChange={(e) => setUsuarioIdFiltro(e.target.value)} />
                      </Form.Group>
                      <Form.Group as={Col} md='2' controlId="formBasicSelect">
                        <Form.Label>Usuário Login</Form.Label>
                        <input type="text" className="form-control" value={usuarioLoginFiltro} onChange={(e) => setUsuarioLoginFiltro(e.target.value)} />
                      </Form.Group>
                      <Form.Group as={Col} md='2' controlId="formBasicSelect">
                        <Form.Label>Usuário Nome</Form.Label>
                        <input type="text" className="form-control" value={usuarioNomeFiltro} onChange={(e) => setUsuarioNomeFiltro(e.target.value)} />
                      </Form.Group>
                      <Form.Group as={Col} md="2" controlId="formBasicDateTime">
                        <Form.Label>Data e Hora Inicio</Form.Label>
                        <input type="datetime-local" className="form-control" value={dataHoraInicioFiltro} onChange={(e) => { setDataHoraInicioFiltro(e.target.value); }} />
                      </Form.Group>
                      <Form.Group as={Col} md="2" controlId="formBasicDateTime">
                        <Form.Label>Data e Hora Fim</Form.Label>
                        <input type="datetime-local" className="form-control" value={dataHoraFimFiltro} onChange={(e) => { setDataHoraFimFiltro(e.target.value); }} />
                      </Form.Group>
                      <Form.Group as={Col} md='2' controlId="formBasicSelect">
                        <Form.Label>IP Acesso</Form.Label>
                        <input type="text" className="form-control" value={ipAcessoFiltro} onChange={(e) => setIpAcessoFiltro(e.target.value)} />
                      </Form.Group>
                      <Form.Group as={Col} md='2' controlId="formBasicSelect">
                        <Form.Label>CPF Cliente</Form.Label>
                        <InputMask required mask="999.999.999-99" type="text" className="form-control" value={cpfClienteFiltro} onChange={(e) => setCpfClienteFiltro(e.target.value)} />
                      </Form.Group>
                      <Form.Group as={Col} md='2' controlId="formBasicSelect">
                        <Form.Label>Nome Cliente</Form.Label>
                        <input type="text" className="form-control" value={nomeClienteFiltro} onChange={(e) => setNomeClienteFiltro(e.target.value)} />
                      </Form.Group>
                      <Form.Group as={Col} md='2' controlId="formBasicSelect">
                        <Form.Label>Matricula Cliente</Form.Label>
                        <input type="text" className="form-control" value={matriculaClienteFiltro} onChange={(e) => setMatriculaClienteFiltro(e.target.value)} />
                      </Form.Group>
                      <Form.Group as={Col} md='2' controlId="formBasicSelect">
                        <Form.Label>Empregador</Form.Label>
                        <select required className="form-select" value={empregadorFiltro} onChange={(e) => setEmpregadorFiltro(e.target.value)}>
                          <option value=""> Todos </option>
                          {empregadores.map((item) => (
                            <option key={item.id} value={item.id!}>
                              {item.id} - {item.nome}
                            </option>
                          ))}
                        </select>
                      </Form.Group>
                      <Form.Group as={Col} md='2' controlId="formBasicSelect">
                        <Form.Label>Promotora</Form.Label>
                        <select required className="form-select" value={promotoraFiltro} onChange={(e) => setPromotoraFiltro(e.target.value)}>
                          <option value=""> Todas </option>
                          {promotoras.map((item) => (
                            <option key={item.id} value={item.id!}>
                              {item.id} - {item.nome}
                            </option>
                          ))}
                        </select>
                      </Form.Group>
                      <Form.Group as={Col} md='2' controlId="formBasicSelect">
                        <Form.Label>Ponto de Venda</Form.Label>
                        <select required className="form-select" value={pontoVendaFiltro} onChange={(e) => setPontoVendaFiltro(e.target.value)}>
                          <option value=""> Todas </option>
                          {pontoVendas.map((item) => (
                            <option key={item.id} value={item.id!}>
                              {item.id} - {item.nome}
                            </option>
                          ))}
                        </select>
                      </Form.Group>
                      <Form.Group as={Col} md="2" controlId="formBasicSelect">
                        <Form.Label>Proposta Solicitada</Form.Label>
                        <select className="form-select" value={propostaSolicitadaFiltro === null ? "" : propostaSolicitadaFiltro.toString()}
                          onChange={(e) => { setPropostaSolicitadaFiltro(e.target.value === "" ? null : (e.target.value === "false" ? false : true)); }}
                        >
                          <option value="">Todos</option>
                          <option value="true">Sim</option>
                          <option value="false">Não</option>
                        </select>
                      </Form.Group>
                    </Row>
                    <div style={{ marginBottom: '10px', display: 'flex', justifyContent: 'space-between' }}>
                      <Button id="App-button-cor-principal-escura" onClick={() => setFiltros(!filtros)}>
                        <FontAwesomeIcon icon={faFilter} style={{ marginRight: '1px' }} />
                      </Button>
                      <Button id="App-button-cor-principal-escura" onClick={() => limparCamposFiltro()}>
                        <FontAwesomeIcon icon={faEraser} style={{ marginRight: '10px' }} />
                        Limpar Filtros
                      </Button>
                      <Button id="App-button-cor-principal-escura" onClick={() => listarLogSimulacao(pageSize)}>
                        <FontAwesomeIcon icon={faRefresh} style={{ marginRight: '1px' }} />
                      </Button>
                    </div>
                  </>
                  : null}
                <div className="table-responsive" style={{ marginTop: '25px', visibility: 'visible', overflowY: 'auto', width: '100%', borderWidth: '1px' }}>
                  <table className="table table-bordered table-striped">
                    <tbody>
                      <tr className="GridHeaderStyle" id="App-button-cor-principal" style={{ color: 'White' }}>
                        <th scope="col" id="App-header-table-esquerda">Usuário ID</th>
                        <th scope="col" id="App-header-table-esquerda">Usuário Login</th>
                        <th scope="col" id="App-header-table-esquerda">Usuário Nome</th>
                        <th scope="col" id="App-header-table-esquerda">Data/Hora</th>
                        <th scope="col" id="App-header-table-esquerda">IP Acesso</th>
                        <th scope="col" id="App-header-table-esquerda">CPF</th>
                        <th scope="col" id="App-header-table-esquerda">Nome</th>
                        <th scope="col" id="App-header-table-esquerda">Matricula</th>
                        <th scope="col" id="App-header-table-esquerda">Empregador</th>
                        <th scope="col" id="App-header-table-esquerda">Promotora</th>
                        <th scope="col" id="App-header-table-esquerda">Ponto de Venda</th>
                        <th scope="col" id="App-header-table-esquerda">Proposta Solicitada?</th>
                      </tr>
                      {logSimulacao.map((item, index) => (
                        <tr className="GridRowStyle">
                          <td>{item?.idUsuario}</td>
                          <td>{item?.loginUsuario}</td>
                          <td>{item?.nomeUsuario}</td>
                          <td>{item?.dtInclusao ? format(new Date(item.dtInclusao), 'dd/MM/yyyy HH:mm:ss') : ''}</td>
                          <td>{item?.ipUsuario}</td>
                          <td>{item?.cpf}</td>
                          <td>{item?.matricula}</td>
                          <td>{item?.nome}</td>
                          <td>{item?.empregador}</td>
                          <td>{item?.promotora}</td>
                          <td>{item?.pontoVenda}</td>
                          <td>{item?.propostaSolicitada ? 'Sim' : 'Não'}</td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                  <ResponsivePagination
                    current={currentPageSimulacao}
                    total={totalPages}
                    onPageChange={setCurrentPageSimulacao} />
                </div>
              </>
            ) : null
            }
            <ScrollToTopButton />
          </>
        )}
      </div >
    </>
  );
}

export default LogsComponent;